import { ModalStyled } from 'components/UI/styled/modal-styled';
import React, { useCallback } from 'react';
import Container from 'react-bootstrap/esm/Container';
import Button from 'react-bootstrap/Button';
import { updateAutoApprovalStatus } from 'services/AutoApprovalService/requests';
import { useHistory } from 'react-router-dom';
import { useAutoApproval } from 'hooks/useAutoApproval';

interface Props {
  isOpen: boolean;
  onClose: () => void;
  // onSubmit: (e) => void;
}

const ConfirmModal = (props: Props) => {
  const { updateStatusAutoApproval } = useAutoApproval();

  const history = useHistory();
  const contextAutoApproval = useAutoApproval();

  const changeStatus = useCallback(async () => {
    if (contextAutoApproval.currentFormData.aprovacaoId) {
      if (contextAutoApproval.currentFormData.status == 'R') {
        updateStatusAutoApproval(
          contextAutoApproval.currentFormData.aprovacaoId,
        );
      }
      history.push('../aprovacao-automatica');
    }
  }, []);

  return (
    <ModalStyled
      show={props.isOpen}
      onHide={props.onClose}
      className="modal-md modal-confirmacao"
    >
      <ModalStyled.Header closeButton>
        <ModalStyled.Title>Deseja ativar a automação?</ModalStyled.Title>
      </ModalStyled.Header>

      <ModalStyled.Body>
        <Container fluid className="pl-0 pr-0">
          <div className="talign-right">
            <Button
              onClick={() => props.onClose()}
              variant="outline"
              type="submit"
            >
              Não
            </Button>
            <Button
              onClick={() => changeStatus()}
              variant="primary"
              type="submit"
            >
              Sim
            </Button>
          </div>
        </Container>
      </ModalStyled.Body>
    </ModalStyled>
  );
};

export default ConfirmModal;
